import { getProductCategories } from 'src/app/utils/analytics/utils/getProductCategories';
import { getProductTotalPrice } from 'src/app/utils/analytics/utils/getProductTotalPrice';
import type { Tealium } from 'src/types/appState';

import {
  EVENT_VIEW_EDIT_PAY_AND_POST,
  PRODUCT_EVENTS_PURCHASE,
} from '../constants';

export const eventName = EVENT_VIEW_EDIT_PAY_AND_POST;

export default (tealium: Tealium) => {
  const {
    addOnAdProductNames,
    adBudgetPurchased,
    adBudgetValue,
    isLinkOutApplyViaSeek,
    jobAdTypeSelected,
    paymentMethod,
    productSetId,
    productSetProductIds,
    productTotalPrice,
  } = tealium;
  return {
    addOnAdProductNames,
    adProductName: [jobAdTypeSelected],
    adProductSetId: productSetId,
    adStatus: 'open',
    jobIsLinkOut: Boolean(isLinkOutApplyViaSeek),
    paymentMethodShown: paymentMethod,
    productCategories: getProductCategories(adBudgetPurchased),
    productEvents: [PRODUCT_EVENTS_PURCHASE],
    productSetProductIds,
    productTotalPrice: getProductTotalPrice(
      adBudgetPurchased,
      productTotalPrice,
      adBudgetValue,
    ),
  };
};
